import i18n from 'i18next';

export const getLang = () => i18n.language;

export const getMediaLanguage = (lang: string) =>
    lang.includes('pl') ? 'PL' : 'ENG';

export const queryKeyWithLanguage = (key: string) => `${key}${getLang()}`;
